export default function TagFilterPills({ tags, selectedTagIds, onChange }) {
  const toggle = (tagId) => {
    if (selectedTagIds.includes(tagId)) {
      onChange(selectedTagIds.filter((id) => id !== tagId));
    } else {
      onChange([...selectedTagIds, tagId]);
    }
  };

  if (!tags || tags.length === 0) return null;

  return (
    <div className="tag-filter-pills">
      {tags.map((tag) => (
        <button
          key={tag.id}
          className={`tag-filter-pill ${selectedTagIds.includes(tag.id) ? 'active' : ''}`}
          style={{
            borderColor: tag.color,
            background: selectedTagIds.includes(tag.id) ? tag.color + '25' : 'transparent',
          }}
          onClick={() => toggle(tag.id)}
        >
          <span className="tag-dot" style={{ background: tag.color }} />
          {tag.name}
        </button>
      ))}
    </div>
  );
}
